import './bootstrap';
import './plugins';

import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.bootstrap5.css';
window.TomSelect = TomSelect;

import 'alpinejs';

import '../../vendor/rappasoft/laravel-livewire-tables/resources/imports/laravel-livewire-tables-all';
import './backend/mileage-report';

import { Calendar } from '@fullcalendar/core';
window.Calendar = Calendar;

import dayGridPlugin from '@fullcalendar/daygrid';
window.dayGridPlugin = dayGridPlugin;

import timeGridPlugin from '@fullcalendar/timegrid';
window.timeGridPlugin = timeGridPlugin;

import listPlugin from '@fullcalendar/list';
window.listPlugin = listPlugin;

import huLocale from '@fullcalendar/core/locales/hu';
window.huLocale = huLocale;

import bootstrapPlugin from '@fullcalendar/bootstrap5';
window.bootstrapPlugin = bootstrapPlugin;

import VanillaContextMenu from 'vanilla-context-menu';
window.VanillaContextMenu = VanillaContextMenu;
